import { $http } from "@/utils/service";

interface wxTicketResponse {
  ticket: string;
}

export class WxTicket {
  public static async getWxTicket(): Promise<wxTicketResponse> {
    try {
      const response = await $http.get<wxTicketResponse>({
        url: "content/openApi/offiaccount/ticket",
        options: { loading: false, mock: false, error: true },
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
